/// <reference types="vite-plugin-svgr/client" />
import React from "react";

import { Col, Container, Row } from "react-bootstrap";

import faLongLasting from "@/assets/icons/faLongLasting.svg";
import faMouse from "@/assets/icons/faMouse.svg";
import faMuscle from "@/assets/icons/faMuscle.svg";
import FaVirus from "@/assets/icons/faVirus.svg";
import faWood from "@/assets/icons/faWood.svg";

import i18n from "../../i18n";

const FeaturesScreen: React.FC = () => {
  const { t } = i18n;
  const features = [
    {
      icon: <img alt={t("Mold-Free")} src={FaVirus} />,
      title: t("Mold-Free"),
      note: t("Contains zero organic material"),
    },
    {
      icon: <img alt={t("Wood-like Workability")} src={faWood} />,
      title: t("Wood-like Workability"),
      note: t("Easily cut and customized"),
    },
    {
      icon: <img alt={t("Superior Durability")} src={faMuscle} />,
      title: t("Superior Durability"),
      note: t("Highly durable and damage-resistant"),
    },
    {
      icon: <img alt={t("Rodent Resistant")} src={faMouse} />,
      title: t("Rodent Resistant"),
      note: t("No hollow walls for pests to nest"),
    },
    {
      icon: (
        <img alt={t("Long Life Cycle")} className="w-100" src={faLongLasting} />
      ),
      title: t("Long Life Cycle"),
      note: t("Engineered for long-term performance"),
    },
  ];

  return (
    <Container
      fluid
      className="screenContainer introContainer featuresContainer"
    >
      <Container className="flexContainer">
        <Row className="w-100">
          <Col xs={12}>
            <h2 className="text-center text-lg-start">
              {t("Additional Features")}
            </h2>
          </Col>
        </Row>

        <div className="horizontal-content-container">
          {features.map((feature) => (
            <div key={feature.title} className="featureContainer">
              <div className="svgContainer mb-0">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.note}</p>
            </div>
          ))}
        </div>
      </Container>
    </Container>
  );
};

export default FeaturesScreen;
